import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchAllAlerts,
  acknowledgeAlertById,
  // Assuming you have a deleteAlert thunk, include it here; otherwise comment out
  // deleteAlert,
} from "../../redux/slices/AlertSlice";
import "./AdminCSS/Details.css";

const AdminAlertsPage = () => {
  const dispatch = useDispatch();
  const { alerts, loading, error } = useSelector((state) => state.alerts);

  const [selectedAlert, setSelectedAlert] = useState(null);

  useEffect(() => {
    dispatch(fetchAllAlerts());
    return () => {
      // Optional: clear alerts if you have a clearAlerts action
      // dispatch(clearAlerts());
    };
  }, [dispatch]);

  const handleAcknowledge = (alertId) => {
    dispatch(acknowledgeAlertById(alertId));
  };

  // Uncomment if you have a deleteAlert thunk
  // const handleDelete = (alertId) => {
  //   if (window.confirm('Are you sure you want to delete this alert?')) {
  //     dispatch(deleteAlert(alertId));
  //   }
  // };

  return (
    <div className="Devices-page">
      {loading && <p className="loading-text">Loading alerts...</p>}
      {error && (
        <p className="error-text">
          Error: Unable to fetch alerts. Please try again later.
        </p>
      )}

      {!loading && !error && alerts.length > 0 && (
        <div className="table-scroll-container">
          <table className="device-table">
            <thead>
              <tr>
                <th>Alert ID</th>
                <th>Time</th>
                <th>Patient ID</th>
                <th>User ID</th>
                <th>Alert Content</th>
                <th>Status</th>
                <th>Operations</th>
              </tr>
            </thead>
            <tbody>
              {alerts.map((alert) => (
                <tr key={alert.id}>
                  <td>{alert.id}</td>
                  <td>{new Date(alert.time).toLocaleString()}</td>
                  <td>{alert.patient_id}</td>
                  <td>{alert.user_id}</td>
                  <td>{alert.alert_content}</td>
                  <td>{alert.acknowledged ? "Acknowledged" : "New"}</td>
                  <td className="operations">
                    {!alert.acknowledged ? (
                      <button
                        className="update-btn"
                        onClick={() => handleAcknowledge(alert.id)}
                      >
                        Acknowledge
                      </button>
                    ) : (
                      <span
                        style={{
                          color: "green",
                          fontWeight: "bold",
                          marginRight: 8,
                        }}
                      >
                        &#10003; {/* checkmark */}
                      </span>
                    )}
                    {/* Uncomment if delete is needed */}
                    {/* <button
                    className="delete-btn"
                    onClick={() => handleDelete(alert.id)}
                  >
                    Delete
                  </button> */}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {!loading && !error && alerts.length === 0 && (
        <p className="empty-text">No alerts found.</p>
      )}
    </div>
  );
};

export default AdminAlertsPage;
